import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ToggleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  children?: ReactNode;
  pressed: boolean;
  onPressedChange: (pressed: boolean) => void;
}

export function Toggle({ children, className = '', onPressedChange, pressed, ...props }: ToggleProps) {
  return (
    <button
      aria-pressed={pressed}
      className={`inline-flex items-center rounded-full border px-4 py-2 text-sm transition ${
        pressed
          ? 'border-[var(--la-gold)] bg-[rgba(201,169,110,0.16)] text-[var(--la-text)]'
          : 'border-white/10 bg-transparent text-[var(--la-text-muted)]'
      } ${className}`.trim()}
      onClick={() => onPressedChange(!pressed)}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
}
